import { pigsAnimations, whiteWolfAnimations } from '../enums/animationNames';
import { backgroundDrawer } from '../game/drawers/background';
import { pigColors, pigIndexes } from '../enums/pigColors';

class GameAnimationService {
  constructor(drawer) {
    this.drawer = drawer;
    this.isAnimationStarted = false;
  }

  get animations() {
    return this.drawer.background.__animations;
  }

  bluePigRun(events, loop) {
    return this.animations[`${pigColors[pigIndexes.blue]}_${pigsAnimations.run}`](events, loop);
  }

  catchPigByIndex(index, events, loop) {
    return this.animations[`${pigColors[index]}_${pigsAnimations.catching}`](events, loop);
  }

  runPigByIndex(index, events, loop) {
    return this.animations[`${pigColors[index]}_${pigsAnimations.run}`](events, loop);
  }

  hidePigByIndex(index) {
    return this.animations[`${pigColors[index]}_${pigsAnimations.$hide}`]();
  }

  showPigByIndex(index) {
    return this.animations[`${pigColors[index]}_${pigsAnimations.$show}`]();
  }

  bluePigFirstPart(events, loop) {
    return this.animations[`${pigColors[pigIndexes.blue]}_${pigsAnimations.firstPartLoop}`](
      events,
      loop
    );
  }

  bluePigRunStart(events, loop) {
    return this.animations[`${pigColors[pigIndexes.blue]}_${pigsAnimations.runStart}`](
      events,
      loop
    );
  }

  redPigRun(events, loop) {
    return this.animations[`${pigColors[pigIndexes.red]}_${pigsAnimations.run}`](events, loop);
  }

  redPigCatching(events, loop) {
    return this.animations[`${pigColors[pigIndexes.red]}_${pigsAnimations.catching}`](events, loop);
  }

  redPigFirstPart(events, loop) {
    return this.animations[`${pigColors[pigIndexes.red]}_${pigsAnimations.firstPartLoop}`](
      events,
      loop
    );
  }

  redPigRunStart(events, loop) {
    return this.animations[`${pigColors[pigIndexes.red]}_${pigsAnimations.runStart}`](events, loop);
  }

  yellowPigRun(events, loop) {
    return this.animations[`${pigColors[pigIndexes.yellow]}_${pigsAnimations.run}`](events, loop);
  }

  yellowPigCatching(events, loop) {
    return this.animations[`${pigColors[pigIndexes.yellow]}_${pigsAnimations.catching}`](
      events,
      loop
    );
  }

  yellowPigFirstPart(events, loop) {
    return this.animations[`${pigColors[pigIndexes.yellow]}_${pigsAnimations.firstPartLoop}`](
      events,
      loop
    );
  }

  yellowPigRunStart(events, loop) {
    return this.animations[`${pigColors[pigIndexes.yellow]}_${pigsAnimations.runStart}`](
      events,
      loop
    );
  }

  yellowPigRunJump(events, loop) {
    return this.animations[`${pigColors[pigIndexes.yellow]}_${pigsAnimations.runJump}`](
      events,
      loop
    );
  }

  wolfRun(events, loop) {
    return this.animations.wolfRun(events, loop);
  }

  wolfCatching(events, loop) {
    return this.animations.wolfCatching(events, loop);
  }

  wolfFirstPart(events, loop) {
    return this.animations.wolfFirstPart(events, loop);
  }

  wolfDoorOpen(events, loop) {
    return this.animations.wolfDoorOpen(events, loop);
  }

  wolfCloseMouth(events, loop) {
    return this.animations.wolfCloseMouth(events, loop);
  }

  whiteWolf(events, loop) {
    return this.animations[whiteWolfAnimations.whiteWolf](events, loop);
  }

  whiteWolfSecond(events, loop) {
    return this.animations[whiteWolfAnimations.whiteWolfSecond](events, loop);
  }

  backgroundLoop() {
    this.isAnimationStarted = true;
    return this.animations.backgroundLoop();
  }

  resetBackground() {
    return this.animations.resetBackground();
  }

  killBackgroundLoop() {
    this.isAnimationStarted = false;
    if (Object.keys(this.animations).length) {
      this.animations.killBackgroundLoop();
    }
  }

  doorOpen() {
    return this.animations.doorOpen();
  }

  doorClose() {
    return this.animations.doorClose();
  }

  hideWall() {
    return this.animations.hideWall();
  }

  showWall() {
    return this.animations.showWall();
  }

  resetAnimations() {
    this.showWall();
    this.showPigByIndex(pigIndexes.yellow);
    this.showPigByIndex(pigIndexes.red);
    this.showPigByIndex(pigIndexes.blue);
    this.redPigFirstPart();
    this.bluePigFirstPart();
    this.yellowPigFirstPart();
    this.wolfFirstPart();
    this.doorClose();
    this.killBackgroundLoop();
    this.resetBackground();
  }
}

export const gameAnimations = new GameAnimationService({
  background: backgroundDrawer,
});
